import { useState, useCallback } from 'react';

import SlideToggle from './components/SlideToggle';

import styles from './styles/index.module.scss';

const path = document.querySelector<HTMLBodyElement>('body').dataset.path;

type Menu = {
  title: string,
  id?: string,
  link?: string,
  direct?: boolean,
  target?: '_blank',
  list?: {
    title: string,
    link: string,
    direct?: boolean,
    target?: '_blank',
  }[],
}[];

const menu: Menu = [
  {
    title: 'つくる',
    link: 'manufacture/section.html',
    // id: 'manufacture',
    // list: [
    //   { title: '業務内容', link: 'manufacture/section.html' },
    //   { title: 'メルコ用語集', link: 'manufacture/dictionary.html' },
    // ],
  },
  {
    title: '伝える',
    link: 'tell/strength.html',
  },
  {
    title: '知る',
    id: 'about',
    list: [
      { title: '会社概要', link: 'know/about.html' },
      { title: 'SDGsの取り組み・ISO', link: 'know/sdgs.html' },
      { title: '拠点案内', link: 'know/base.html' },
      { title: '資料ダウンロード', link: 'download.html' },
    ],
  },
  {
    title: '働く',
    id: 'recruit',
    list: [
      { title: '採用TOP', link: 'recruit/', target: '_blank' },
      { title: '先輩の声', link: 'recruit/#interview', target: '_blank' },
      { title: '募集要項', link: 'recruit/#job', target: '_blank' },
    ],
  },
  //{
  //  title: '買う',
  //  link: 'https://melco-susnet.com/',
  //  direct: true,
  //  target: '_blank',
  //},
];

export default function HeaderNav() {
  const [open, setOpen] = useState(false);

  const handleOpen = useCallback(() => {
    setOpen((prev) => !prev);
  }, []);

  const [childOpen, setChildOpen] = useState('');

  const handleChilcOpen: React.MouseEventHandler<HTMLButtonElement> = useCallback((event) => {
    const target = event.currentTarget;
    const value = target.value;

    setChildOpen((prev) => {
      return prev === value ? '' : value;
    });
  }, []);

  return (
    <>
      <button className={styles.hamburger} onClick={handleOpen} aria-expanded={open}>
        <div className={styles.hamburgerBox}>
          <span className={styles.bar} />
          <span className={styles.bar} />
        </div>
      </button>
      <nav className={styles.nav} aria-hidden={!open}>
        <div className={styles.menuWrap}>
          <div className={styles.telWrap}>
            <span className={styles.telTitle}>TEL</span>
            <span className={styles.telNumber}>0224-73-7011</span>
          </div>
          <ul className={styles.menu}>
            {
              menu.map((item, itemIndex) => {
                return (
                  <li className={styles.item} key={itemIndex}>
                    {
                      item.link ? (
                        <a className={styles.link} href={item.direct ? item.link : `${path}${item.link}`} target={item.target}>{item.title}</a>
                      ) : (
                        <>
                          <button className={styles.btn} value={item.id} onClick={handleChilcOpen} aria-selected={item.id === childOpen}>{item.title}</button>
                          <div className={styles.childWrap}>
                            <SlideToggle open={item.id === childOpen}>
                              <ul className={styles.child}>
                                {
                                  item.list.map((child, childIndex) => {
                                    return (
                                      <li className={styles.childItem} key={childIndex}>
                                        <a className={styles.childLink} href={child.direct ? child.link :`${path}${child.link}`} target={child.target}>{child.title}</a>
                                      </li>
                                    );
                                  })
                                }

                              </ul>
                            </SlideToggle>
                          </div>
                        </>
                      )
                    }
                  </li>
                );
              })
            }
          </ul>
        </div>
        <div className={styles.contactWrap}>
          <a className={styles.contact} href={`${path}contact.html`}>お問合せ</a>
          <a className={styles.download} href={`${path}download.html`}>資料ダウンロード</a>
        </div>
      </nav>
    </>
  );
}